/* --- SENTRY --- */
var trackErrors = true;

if(typeof Raven === 'object' && trackErrors === true)
	Raven.config('https://c8ecc5dbb93645418ef0e8af339bdfa1@sentry.io/1400308').install();

/* ######################################################################################################################## */
/* GENERIC VARS ########################################################################################################### */
/* ######################################################################################################################## */
var speed = 300;
var	ease  = 'easeInOutQuart';

/* ######################################################################################################################## */
/* SCRIPTS (WINDOW ONLOAD) ################################################################################################ */
/* ######################################################################################################################## */
jQuery(window).load(function()
{
});

/* ######################################################################################################################## */
/* SCRIPTS (DOCUMENT READY) ############################################################################################### */
/* ######################################################################################################################## */
jQuery(document).ready(function($)
{
	cookieNotice();                 // Cookie notice
	responsiveImg();                // Responsive images
	stickyHeader();                 // Sticky header
	modalWindow(speed, ease);       // Modal window
	formValidation(speed, ease);    // Form validation
	mainNavigation();               // Main navigation
	// viewportFixing();               // Viewport fixing

	// Prevent default anchor action
	jQuery('a').on('click', function(e)
	{
		if(jQuery(this).attr('href') == '#')
			e.preventDefault();
	});

	// Cycle
	jQuery('.cycle').each(function(index, element)
	{
		var classSlide = jQuery(element).attr('data-cycle-slides').substr(4);

		if(jQuery(classSlide, element).length > 1)
		{
			jQuery(element).cycle(
			{
				easing : ease,
				log    : false
			});
		}
	});

	// Sticky sidebar
	jQuery('.js-sticky_sidebar').stickySidebar(
	{
		topSpacing : 82
	});

	// Goto ID
	jQuery('body').delegate('.goToID', 'click', function(e)
	{
		e.preventDefault();

		var idDiv     = jQuery(this).attr('href');
		var offsetTop = jQuery(idDiv).offset().top;
		var scrollPX  = jQuery('.header_rhc').outerHeight(true);

		jQuery('html, body').animate(
		{
			scrollTop : offsetTop - scrollPX
		}, speed * 2, ease);
	});

	// Toggle Map
	jQuery('body').delegate('.toggleMap', 'click', function(e)
	{
		e.preventDefault();

		var jQthis = jQuery(this);
		var idMap  = jQthis.attr('href');

		jQuery(this).toggleClass('open');

		jQuery(idMap).stop(true).slideToggle(speed, ease, function()
		{
			if(jQthis.hasClass('open'))
			{
				var offsetTop = jQuery(idMap).offset().top;
				var scrollPX  = jQuery('.header_rhc').outerHeight(true);

				jQuery('html, body').animate(
				{
					scrollTop : offsetTop - (scrollPX + jQuery('.product_listing_controls').outerHeight(true))
				}, speed, ease);
			}
		});
	});

    jQuery('.js-onchange-submit').on('change', function() {
        jQuery(this).closest('form').submit();
    });

	// Slick
	$('.js-slick').each(function()
	{
		if($('.js-slick_slide', this).length > 0)
			$(this).slick().addClass('is-visible');
	});

	// Gallery
	$('.js-modal-gallery_trigger').on('click', function(e)
	{
		var $this        = $(this);
		var galleryID    = '#slick-' + $this.attr('href').substring(1);
		var gallerySlide = $this.attr('data-slide');

		$(galleryID).slick('slickGoTo', gallerySlide - 1);
	});

	$('.modal-gallery_btn').on('click', function(e)
	{
		e.preventDefault();
		e.stopPropagation();
	});
});

/* ######################################################################################################################## */
/* SCRIPTS (WINDOW RESIZE) ################################################################################################ */
/* ######################################################################################################################## */
jQuery(window).bind('resizeEnd', function()
{
	responsiveImg();     // Responsive images
	// viewportFixing();    // Viewport fixing
});

// resizeEnd
jQuery(window).resize(function()
{
	if(this.resizeTO)
		clearTimeout(this.resizeTO);

	this.resizeTO = setTimeout(function()
	{
		jQuery(this).trigger('resizeEnd');
	}, 100);
});

/* ######################################################################################################################## */
/* MAIN NAVIGATION ######################################################################################################## */
/* ######################################################################################################################## */
function mainNavigation()
{
	// Trigger
	jQuery('#trigger-main-navigation, #close-main-navigation').on('click', function(e)
	{
		e.preventDefault();
		e.stopPropagation();

		if(jQuery('#main-navigation').hasClass('open'))
		{
			jQuery('#main-navigation').removeClass('open');
			document.body.style.overflow = "";
		}
		else
		{
			jQuery('#main-navigation').addClass('open');
			document.body.style.overflow = "hidden";
		}
	});

	// Close
	jQuery(document)
		.on('click', function(e)
		{
			if(jQuery('#main-navigation.open').length > 0)
			{
				if(jQuery(e.target).closest('#main-navigation > ul').length === 0)
				{
					jQuery('#main-navigation').removeClass('open');
					document.body.style.overflow = "";
				}
			}
		})
		.keyup(function(e)
		{
			if(jQuery('#main-navigation.open').length > 0)
			{
				if(e.keyCode == 27)
				{
					jQuery('#main-navigation').removeClass('open');
					document.body.style.overflow = "";
				}
			}
		});
}

/* ######################################################################################################################## */
/* IS IN VIEWPORT ######################################################################################################### */
/* ######################################################################################################################## */
jQuery.fn.isInViewport = function()
{
	var elementTop     = jQuery(this).offset().top;
	var elementBottom  = elementTop + jQuery(this).outerHeight();
	var viewportTop    = jQuery(window).scrollTop();
	var viewportBottom = viewportTop + jQuery(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

/* ######################################################################################################################## */
/* VIEWPORT FIXING ######################################################################################################## */
/* ######################################################################################################################## */
/*
function viewportFixing()
{
	var header       = jQuery('#header');
	var headerRHC    = jQuery('.header_rhc', '#header');
	var windowHeight = jQuery(window).height();

	if(headerRHC.css('position') == 'fixed')
	{
		jQuery('#wrapper').css('padding-top', headerRHC.height());
		jQuery('.hero.hTall').css('height', windowHeight - header.height() - headerRHC.height());
		jQuery('.hero.hShort').css('height', ((windowHeight * 75) / 100) - header.height() - headerRHC.height());
	}
	else
	{
		jQuery('#wrapper').css('padding-top', header.height());
		jQuery('.hero.hTall').css('height', windowHeight - header.height());
		jQuery('.hero.hShort').css('height', ((windowHeight * 75) / 100) - header.height());
	}
}
*/
